<template>
  <v-card>
    <v-toolbar card color="white">
      <v-text-field
        v-model="search"
        :placeholder="$t('action.buttons.search')"
        flat
        solo
        prepend-icon="search"
        hide-details
      />
      <meta-button
        v-if="can('create', 'event')"
        type="new"
        :loading="loading"
        @click="$emit('create')"
      />
    </v-toolbar>
    <template v-if="pageList.length">
      <v-divider />
      <v-card-text class="pa-0">
        <v-list two-line subheader>
          <template v-for="(event, index) in pageList">
            <v-divider v-if="index" :key="index + 700" inset />

            <v-list-tile
              :key="index + 200"
              avatar
              @click="$emit('setEvent', event)"
            >
              <v-list-tile-content>
                <v-list-tile-title class="mb-1">
                  <v-layout wrap row align-center>
                    <v-avatar size="25">
                      <img :src="event.eventIcon" class="mx-2" />
                    </v-avatar>
                    <span class="mx-1 blue--text">{{ event.minute }}'</span>
                    <span v-if="event.second" class="mr-1 blue--text"
                      >{{ event.second }}"</span
                    >
                    <span class="mx-2">{{ event.typeEvent }}</span>
                  </v-layout>
                </v-list-tile-title>

                <v-list-tile-sub-title
                  v-if="event.player || event.team"
                  class="mt-1 body-1"
                >
                  <v-layout wrap row align-center>
                    <v-avatar size="25">
                      <v-img :src="event.teamLogo" class="mx-2" />
                    </v-avatar>
                    <span class="mx-2">{{ event.player || event.team }}</span>
                  </v-layout>
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-layout wrap row>
                  <v-flex d-flex>
                    <v-icon :class="{ 'amber--text': event.votesAverage > 0 }">
                      start
                    </v-icon>
                    <span style="min-width: 32px">
                      {{ event.votesAverage }}
                    </span>
                  </v-flex>
                </v-layout>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
      </v-card-text>
      <template v-if="totalPages > 1">
        <v-divider />
        <v-card-actions>
          <v-layout row wrap justify-center py-2>
            <v-pagination
              v-model="page"
              :length="totalPages"
              :total-visible="totalPages > 5 ? 5 : undefined"
              color="primary"
              @change="(val) => $emit('changePage', val)"
            />
          </v-layout>
        </v-card-actions>
      </template>
    </template>
  </v-card>
</template>

<script>
import { filterArray } from '@/helpers/utils'

export default {
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: '',
      page: 1,
      itemByPage: 5,
    }
  },
  computed: {
    filteredList() {
      return filterArray(this.items, this.search)
    },
    pageList() {
      let start = (this.page - 1) * this.itemByPage
      return this.filteredList.slice(start, start + this.itemByPage)
    },
    totalPages() {
      return Math.ceil(this.filteredList.length / this.itemByPage)
    },
  },
  watch: {
    items: {
      handler: function () {
        this.page = 1
      },
      deep: true,
    },
  },
}
</script>

<style></style>
